import type { HTMLAttributes } from 'vue'

export const ArrowRight = (props: HTMLAttributes) => {
  const color = computed(() => {
    return props.color || 'var(--colors-bg-icon-quaternary)'
  })
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.4973 8.19551C10.8767 7.80982 10.8767 7.19114 10.4973 6.80545L6.9381 3.18744C6.73644 2.98244 6.40746 2.97761 6.19987 3.17661C5.98957 3.37821 5.98341 3.71242 6.18614 3.92162L9.6542 7.50048L6.18756 11.0582C5.98333 11.2678 5.98655 11.6029 6.19479 11.8085C6.40429 12.0154 6.74192 12.013 6.9484 11.8031L10.4973 8.19551Z"
        fill={color.value}
        stroke={color.value}
        stroke-width="0.6"
      />
    </svg>
  )
}
